export default __webpack_public_path__ + "static/theconceptgroup-4f8752c0432aa4c996ea311d8af46b56.png";